<template>
  <div>
    <box-summary/>
    <div class="box">
      <v-server-table
        ref="datatable"
        :url="api"
        :name="tableName"
        :columns="columns"
        :options="options">

        <template slot="beforeTable">
          <datatable-loader :name="tableName"/>
        </template>

        <template slot="beforeFilter">
          <div class="m-l-sm float-right mode-filter">
            <select 
              class="form-control c-select" 
              @change="setTaxReportExport">
              <option :value="null">Selected Date Range</option>
              <option :value="1">Monthly Tax</option>
              <option :value="2">Daily Tax</option>
            </select>
          </div>
        </template>
      </v-server-table>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import boxSummary from './tax_box_summary.vue';
const TableName = 'VUETABLE_TAX';
export default {
    components: {
        boxSummary,
    },

    data: function() {
        var that = this;
        return {
            tableName: TableName,
            columns: ['name', 'taxable_amount', 'tax_collected'],
            options: {
                texts: {
                    title: 'Taxes',
                    description: 'Shows tax sales details',
                },
                headings: {
                    name: 'Name',
                    taxable_amount: 'Taxable Amount',
                    tax_collected: 'Tax Collected',
                },
                customFilters: ['outlet_id', 'since', 'until', 'filters'],
                useReportFilter: true,
                initFilters: {
                    outlet_id: that.$store.getters.activeOutlet,
                    since: that.$store.getters.startDate.format(),
                    until: that.$store.getters.endDate.format(),
                },
                pdf_url: Laroute.route('franchise.report.tax.exportAsFile', {
                    type: 'PDF',
                }),
                csv_url: Laroute.route('franchise.report.tax.exportAsFile', {
                    type: 'CSV',
                }),
                xls_url: Laroute.route('franchise.report.tax.exportAsFile', {
                    type: 'XLSX',
                }),
                actionButtons: [
                    {
                        title: 'Export Details',
                        action: () => {
                            this.downloadExportDetails();
                        },
                    },
                ],
            },
        };
    },

    computed: {
        ...mapState('tillFilter', ['filters']),

        api() {
            return Laroute.route('franchise.report.tax.index');
        },
    },

    watch: {
        filters: function(to, from) {
            if (to === from) return;

            this.setFilter();
        },
    },

    methods: {
        setTaxReportExport(e) {
            const val = e.target.value || null;
            this.$refs.datatable.userControlsColumns = true;
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'type',
                value: val,
            });

            if (val == 1) {
                this.$refs.datatable.userColumnsDisplay = [
                    'tax_date',
                    'name',
                    'taxable_amount',
                    'service_charge',
                    'tax_collected',
                ];

                this.columns = [
                    'tax_date',
                    'name',
                    'taxable_amount',
                    'service_charge',
                    'tax_collected',
                ];

                this.options.headings = {
                    tax_date: 'Date',
                    name: 'Tax Name',
                    taxable_amount: 'Subtotal Amount (RM)',
                    service_charge: 'Service Charge (RM)',
                    tax_collected: 'Tax Collected (RM)',
                };
            } else if (val == 2) {
                this.$refs.datatable.userColumnsDisplay = [
                    'tax_date',
                    'taxable_amount',
                    'service_charge',
                    'tax_collected',
                ];

                this.columns = [
                    'tax_date',
                    'taxable_amount',
                    'service_charge',
                    'tax_collected',
                ];

                this.options.headings = {
                    tax_date: 'Date',
                    taxable_amount: 'Subtotal Amount (RM)',
                    service_charge: 'Service Charge (RM)',
                    tax_collected: 'Tax Collected (RM)',
                };
            } else {
                this.$refs.datatable.userColumnsDisplay = [
                    'name',
                    'taxable_amount',
                    'tax_collected',
                ];

                this.columns = ['name', 'taxable_amount', 'tax_collected'];

                this.options.headings = {
                    name: 'Name',
                    taxable_amount: 'Taxable Amount',
                    tax_collected: 'Tax Collected',
                };
            }
        },

        downloadExportDetails() {
            let url = Laroute.route('franchise.report.tax.exportAsFile', {
                type: 'CSV',
            });

            window.open(
                `${url}?${this.$refs.datatable.getQueryParams() +
                    '&details=true'}`,
            );
        },

        setFilter() {
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'filters',
                value: this.filters,
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/tax/vuetable_tax.vue